import React, { useRef } from 'react';
import { i18n } from 'src/common';
import { Button, Flex, Text } from 'src/components';
import {
  InsuranceNeedsForm,
  InsuranceNeedsFormData,
  InsuranceNeedsFormType,
} from 'src/components/forms/insuranceNeeds.form';
import { FormRef } from 'src/components/forms/form';
import BaseModal from './base.modal';

export interface InsuranceNeedsModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: InsuranceNeedsFormData) => void;
  initialData: InsuranceNeedsFormData;
  formItems?: Array<InsuranceNeedsFormType>;
  loading?: boolean;
}

export const InsuranceNeedsModal: React.FC<InsuranceNeedsModalProps> = ({
  open,
  onClose,
  onSubmit,
  initialData,
  formItems = ['selectedRiskIds'],
  loading,
}) => {
  const formRef = useRef<FormRef>(null);

  return (
    <BaseModal open={open} onClose={onClose}>
      <Flex vertical gap={24}>
        <Text type="large" bold>
          {i18n.t('components.modals.insuranceNeedsModal.title')}
        </Text>
        <InsuranceNeedsForm
          ref={formRef}
          data={initialData}
          formItems={formItems}
          onSubmit={onSubmit}
        />
        <Flex gap={12}>
          <Button
            text={i18n.t('components.modals.insuranceNeedsModal.save')}
            btnType="primary"
            onClick={() => formRef.current?.submitForm?.()}
            disabled={loading}
          />
          <Button
            text={i18n.t('components.modals.insuranceNeedsModal.close')}
            btnType="textBlack"
            onClick={onClose}
          />
        </Flex>
      </Flex>
    </BaseModal>
  );
};
